<div class="col-size6 t-col-size8 m-col-size4">
  <div class="mapfre-fs-m-r mapfre-fw-300 mapfre-mt-m">
    {{ 'PROFILE.ENTITIES.TITLE' | translate }}
  </div>

  <ul>
    <li>
      <span class="mapfre-fs-xs-r mapfre-fw-400 medium-dark">{{ 'PROFILE.ENTITIES.INSURANCE_COMPANY' | translate }}</span>
    </li>
    <li>
      <span class="mapfre-fs-xs-r mapfre-fw-400 medium-dark">{{ 'PROFILE.ENTITIES.INSURANCE_LIFE' | translate }}</span>
    </li>
    <li>
      <span class="mapfre-fs-xs-r mapfre-fw-400 medium-dark">{{ 'PROFILE.ENTITIES.SOCIETY_INVESTMENT' | translate }}</span>
    </li>
    <li>
      <span class="mapfre-fs-xs-r mapfre-fw-400 medium-dark">{{ 'PROFILE.ENTITIES.LIFE_PENSIONS' | translate }}</span>
    </li>
    <li>
      <span class="mapfre-fs-xs-r mapfre-fw-400 medium-dark">{{ 'PROFILE.ENTITIES.MANAGEMENT_MEDICAL_CENTERS' | translate }}</span>
    </li>
    <li>
      <span class="mapfre-fs-xs-r mapfre-fw-400 medium-dark">{{ 'PROFILE.ENTITIES.MAPFRE_CLUB' | translate }}</span>
    </li>
    <li>
      <span class="mapfre-fs-xs-r mapfre-fw-400 medium-dark">{{ 'PROFILE.ENTITIES.MULTISERVICES' | translate }}</span>
    </li>
  </ul>
</div>